import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();

  const { background, secondary } = theme.palette;
  const { md, sm } = theme.breakpoints;
  const { spacing } = theme;

  const componentWrapper = css`
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 75px 25px;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;

    & h2 {
      text-align: center;

      @media (max-width: ${`${sm}px`}) {
        text-align: left;
      }
    }

    @media (max-width: ${`${md}px`}) {
      padding: 50px 25px;
    }
  `;

  const mobileBorderStyles = css`
    @media (max-width: ${`${sm}px`}) {
      padding: 50px 15px;
    }
  `;

  const reviewsWrapper = css`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: ${spacing(3)};
    gap: 145px;

    @media (max-width: ${`${md}px`}) {
      gap: 75px;
    }

    @media (max-width: ${`${sm}px`}) {
      flex-direction: column;
      align-items: center;
      gap: 25px;
    }
  `;

  const reviewStyle = css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  const reviewLogo = css`
    & img {
      height: auto;
      margin-bottom: 15px;
    }
  `;

  const reviewsStars = css`
    display: flex;
    align-items: center;
    margin-bottom: ${spacing(1)};
    gap: ${spacing(0)};
  `;

  const reviewNumberStyle = css`
    & i {
      font-size: 14px;
      line-height: 17px;
    }
  `;

  const slideshowWrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    width: 100%;
  `;

  const quincyStyles = css`
    padding: 75px 25px 35px;
    max-width: 1216px;

    & h2 {
      font-family: 'Quincy CF';
      font-size: 35px;
      line-height: 40px;

      @media (max-width: ${`${md}px`}) {
        max-width: 557px;
        margin: 0 auto;
      }

      @media (max-width: ${`${sm}px`}) {
        text-align: left;
        padding: 0 10px;
      }
    }

    @media (max-width: ${`${sm}px`}) {
      padding: 50px 10px 25px;
    }
  `;

  const quincyReviewsWrapper = css`
    @media (max-width: ${`${md}px`}) {
      flex-direction: row;
      align-items: center;
      gap: 75px;
    }

    @media (max-width: ${`${700}px`}) {
      flex-direction: column;
      align-items: center;
      gap: 25px;
      border: 2px solid ${background.gray};
      border-radius: 15px;
      padding: 35px 25px;
    }
  `;

  const quincyStars = css`
    margin-bottom: 10px;
  `;

  const quincyLogo = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;

    & img {
      height: auto;
      margin-bottom: 0px;
    }
  `;

  const mobileBorderWrapper = css`
    @media (max-width: ${`${sm}px`}) {
      border: 1px solid ${background.gray3};
      border-radius: 15px;
      padding: 35px 15px;
      text-align: left;
    }
  `;

  return {
    componentWrapper,
    mobileBorderStyles,
    reviewsWrapper,
    reviewStyle,
    reviewLogo,
    reviewsStars,
    reviewNumberStyle,
    slideshowWrapper,
    quincyStyles,
    quincyReviewsWrapper,
    quincyStars,
    quincyLogo,
    mobileBorderWrapper,
  };
};

export default useStyle;
